import { Container, Grid } from '@mui/material';
import Reveal from '../../atome/motion/reveal';
import { Eyebrow } from '../../atome/motion/motion.styled';
import {
  FounderCopy,
  FounderSection,
  Pillars,
  PortraitBacking,
  PortraitFrame,
  PortraitInset,
  PortraitStack,
  Quote,
  Signature,
  SignatureMark,
  Watermark,
} from './founder.styled';

/**
 * Owner spotlight — the face behind the brand.
 * NOTE: the quote and body copy below are placeholders written to fit the
 * layout; swap them for Karen's own words before launch.
 */
const Founder = () => (
  <FounderSection id="founder">
    <Watermark aria-hidden="true">Klarity</Watermark>

    <Container maxWidth="lg">
      <Grid container spacing={{ xs: 5, md: 8 }} alignItems="center">
        <Grid size={{ xs: 12, md: 5 }}>
          <Reveal from="left">
            <PortraitStack>
              <PortraitBacking aria-hidden="true" />
              <PortraitFrame>
                <img
                  src="/img/klarity-karen.jpg"
                  alt="Karen, founder of Klarity"
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.src = '/img/klarity-cover.jpg';
                  }}
                />
              </PortraitFrame>
              <PortraitInset>
                <img
                  src="/img/klarity-karen-product.jpg"
                  alt="Karen holding the Klarity eye cream"
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.src = '/img/klarity-product.jpg';
                  }}
                />
              </PortraitInset>
            </PortraitStack>
          </Reveal>
        </Grid>

        <Grid size={{ xs: 12, md: 7 }}>
          <Reveal from="right" delay={120}>
            <FounderCopy>
              <Eyebrow>Behind Klarity</Eyebrow>
              <h2>Made by someone who uses it every event</h2>

              <Quote>
                I wanted one product I could trust completely — so I kept refining it until I had
                nothing left to remove.
              </Quote>

              <p>
                It started with a simple problem: puffy, tired eyes before every event, and nothing
                that worked fast enough. The formula was reworked in Beirut, again and again, until
                it did one thing properly — lift the eye area and soften dark circles in two minutes.
              </p>

              <Signature>
                <SignatureMark aria-hidden="true">K</SignatureMark>
                <div>
                  <strong>Karen</strong>
                  <span>Founder &amp; formulator</span>
                </div>
              </Signature>

              <Pillars>
                <div>
                  <strong>2 min</strong>
                  <span>Visible results</span>
                </div>
                <div>
                  <strong>Small batch</strong>
                  <span>Made in Lebanon</span>
                </div>
                <div>
                  <strong>Hand checked</strong>
                  <span>Every single order</span>
                </div>
              </Pillars>
            </FounderCopy>
          </Reveal>
        </Grid>
      </Grid>
    </Container>
  </FounderSection>
);

export default Founder;
